import React, { useState } from "react"
import Header from "../components/header";
import TipButton from "../components/tipButton";
import FAQModal from "../components/faqModal";
import Footer from "../components/footer";
import "../styles/profile.css"
import character from "../images/character.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faPalette, faCartShopping } from "@fortawesome/free-solid-svg-icons";

//TODO: Add contact button link
const ProfilePage = () => {
  const [faqOpen, setFaqOpen] = useState(false);

  return (
    <main style={{ backgroundColor: "#0a0a0a", minHeight: "100vh", color: "#fff" }}>
      <Header onOpenFAQ={() => setFaqOpen(true)} />

      <FAQModal isOpen={faqOpen} onClose={() => setFaqOpen(false)} />


      <section className="container">
        <div className="card">
          {/* Image */}
          <div className="profile-img">
            <img src={character} alt="Character" />
          </div>

          {/* Name */}
          <div className="name">
            <span className="small">PORTFOLIO</span>
            <span className="big">KOYASUMI</span>
          </div>

          {/* Info */}
          <div className="info">
            <p>
              hello i’m chisel! i am a vietnamese-american illustrator who specializes in character design, storyboard, and comic art. my work often explores love, grief, death, youth, and allegories to the human condition and psyche through an eastern cultural lens.
            </p>
            <p>
               i take a lot of inspiration from asian cinema and aspire to be an art director one day! 
            </p>
            <p>
              this website will serve as an archive of my personal creative development. thank you for following me on my art journey ♡ 
            </p>
          </div>

          <div className="social-buttons" aria-label="Social links">
            <a href="https://www.instagram.com/koyasumi" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://x.com/koyasumii" target="_blank" rel="noopener noreferrer" aria-label="X">
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
            <a href="https://vgen.co/koyasumi" target="_blank" rel="noopener noreferrer" aria-label="VGen">
              <FontAwesomeIcon icon={faPalette} />
            </a>
            <a href="https://www.inprnt.com/profile/chisel/" target="_blank" rel="noopener noreferrer" aria-label="Shop">
              <FontAwesomeIcon icon={faCartShopping} />
            </a>
          </div>
        </div>

        {/* Buttons */}
        <div className="profile-actions">
          <div className="buttons">
            <div className="tip-overlap">
              <TipButton />
            </div>
            <button onClick={() => setFaqOpen(true)}>FAQ</button>
            <button>CONTACT</button>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}

export default ProfilePage